import { z } from "zod";

// The hops a scan makes, and how far each one has got. Shared so the run
// pipeline and the TOV cascade describe stage progress with one vocabulary
// instead of each re-declaring the same three states.

export const RUN_STAGE_KEYS = [
  "crawl",
  "fetch",
  "analyse",
  "canonicalize",
] as const;
export const RUN_STAGE_KEY = {
  CRAWL: "crawl",
  FETCH: "fetch",
  ANALYSE: "analyse",
  CANONICALIZE: "canonicalize",
} as const satisfies Record<string, RunStageKey>;
export const RunStageKeySchema = z.enum(RUN_STAGE_KEYS);
export type RunStageKey = z.infer<typeof RunStageKeySchema>;

/**
 * `waiting` nothing has entered the stage yet; `active` work is in it; `done`
 * everything that entered has left. A stage with failures is still `done` once
 * it has drained — failures are carried separately so a partly failed stage is
 * not reported as one that never finished.
 */
export const PIPELINE_STAGE_STATES = ["waiting", "active", "done"] as const;
export const PIPELINE_STAGE_STATE = {
  WAITING: "waiting",
  ACTIVE: "active",
  DONE: "done",
} as const satisfies Record<string, PipelineStageState>;
export const PipelineStageStateSchema = z.enum(PIPELINE_STAGE_STATES);
export type PipelineStageState = z.infer<typeof PipelineStageStateSchema>;
